import React, { FC } from "react";

import { useApisMembersQuestionAnswersClicksCreate, useBoolean } from "~/hooks";

import { Icon } from "~/components/atoms";

import { QuestionAnswerType } from "~/domains";

type PropsType = {
  questionAnswer: QuestionAnswerType;
};

export const QuestionAnswer: FC<PropsType> = ({
  questionAnswer,
}: PropsType) => {
  const { questionContent, answerContent, link } = questionAnswer;
  const { setTrue, setFalse, isChecked } = useBoolean(false);

  const { mutate: clickPostRequest } =
    useApisMembersQuestionAnswersClicksCreate();

  const handleTrue = () => {
    setTrue();
    clickPostRequest({ questionAnswerId: questionAnswer.id });
  };

  return (
    <div className="bg-white border-2 border-primary-300 rounded-xl hover:shadow-sm transition-all duration-300 overflow-hidden">
      <div
        className="flex justify-between cursor-pointer items-center font-semibold py-4 px-6 hover:bg-gradient-to-r hover:from-primary-200 hover:to-primary-300 transition-all duration-300"
        onClick={isChecked ? setFalse : handleTrue}
      >
        <div className="flex items-center flex-1 min-w-0">
          <div className="flex-shrink-0 pb-1 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-800 rounded-full flex items-center justify-center shadow-md">
            <span className="text-white font-bold">Q</span>
          </div>
          <p
            className={`text-secondary-900 font-medium leading-relaxed ml-4 ${
              isChecked ? "" : "truncate"
            } min-w-0`}
          >
            {questionContent}
          </p>
        </div>
        <div className="flex-shrink-0 ml-4">
          <div className="w-8 h-8 rounded-full bg-secondary-100 hover:bg-white flex items-center justify-center transition-all duration-300 shadow-sm">
            {isChecked ? (
              <Icon
                icon="ioChevronUpOutline"
                size="1.25rem"
                className=" text-primary-600"
              />
            ) : (
              <Icon
                icon="ioChevronDown"
                size="1.25rem"
                className=" text-primary-600"
              />
            )}
          </div>
        </div>
      </div>
      {isChecked && (
        <div className="border-t-2 border-primary-300 bg-gradient-to-br from-secondary-100 to-primary-200">
          <div className="p-6 space-y-6">
            <div className="text-secondary-900 leading-relaxed whitespace-pre-line font-medium">
              {answerContent}
            </div>
            {link && (
              <div className="space-y-4">
                <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-primary-600 to-primary-800 text-white px-5 py-2 rounded-full text-sm font-semibold shadow-md">
                  <span>参考リンク</span>
                </div>
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="block text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200 underline decoration-2 decoration-primary-400 hover:decoration-primary-600"
                >
                  {link}
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
